// extracted by mini-css-extract-plugin
module.exports = {"transitionheight":"header_transitionheight__HZHdu"};